import React from 'react';
import Cards from '../../components/Product_Index/Cards/Cards';

function MenPage() {
  
    return (
        <div>
            <Cards />
        </div>
    );
}

export default MenPage;